import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import axios from 'axios'
import App from './App'
import './index.css'
import { apiBaseUrl, googleClientId, isTestMode } from './config'

axios.defaults.withCredentials = true
if (apiBaseUrl) axios.defaults.baseURL = apiBaseUrl

const root = ReactDOM.createRoot(document.getElementById('root')!)

const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
)

root.render(
  <React.StrictMode>
    {isTestMode || !googleClientId ? app : <GoogleOAuthProvider clientId={googleClientId}>{app}</GoogleOAuthProvider>}
  </React.StrictMode>,
)
